import { drawImage } from './images.js'
import { GetScene } from './sceneController.js'

let frame = 0
let animationSpeed = 0.2
let maxFrame = 7
let scene = null

function Reset() {
    frame = 0
    scene = null
}

function frameRect() {
    return { x: parseInt(frame) * 64, y: 0, w: 64, h: 64 }
}

function AnimationFrame(delta) {
    if (!scene) {
        scene = GetScene('transition-clouds-in')
    }
    if (scene.onUpdate) {
        scene.onUpdate({
            frame: frame, maxFrame: maxFrame
        })
    }

    drawImage('transition-clouds', 0, 0, frameRect())

    if (frame <= maxFrame) {
        frame += delta * animationSpeed
    }
    frame = frame > maxFrame ? maxFrame : frame
}

export { AnimationFrame, Reset }